import { render } from "./Favorite.vue?vue&type=template&id=03bff7c2"
import script from "./Favorite.vue?vue&type=script&lang=ts"
export * from "./Favorite.vue?vue&type=script&lang=ts"
script.render = render

export default script